import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/CardsSettings.scss";
import CardsSettingsTemplate from "./CardsSettingsTemplate";
import RequestCardTemplate from "./RequestCardTemplate";
import {useSelector} from "react-redux";


function CardsSettings() {
    const [activeButton, setActiveButton] = useState({ name: "Cards" });

    const handleButtonClick = (event) => {
        setActiveButton({ name: event.target.innerText });
    };

    const {flag} = useSelector(state => state.transferResponse);

    useEffect(() => {
        if ([0,1].includes(flag)) {
            setActiveButton({ name: "Cards" });
        }
    } ,[flag]);

    return (
        <>
            <HeaderComponent title="Cards Settings" />
            <div className="CardsSettingsPage">
                <div className="container-fluid CardsSettingsPagecontainer">
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Cards" ? "active" : ""}`} onClick={handleButtonClick}>Cards</button>
                                <button className={`navButton ${activeButton.name === "Request Card" ? "active" : ""}`} onClick={handleButtonClick}>Request Card</button>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>

                    <div className="row">
                        {activeButton.name === "Cards" && <CardsSettingsTemplate setActiveButton={setActiveButton}/> }
                        {activeButton.name === "Request Card" && <RequestCardTemplate activeButton={activeButton}/>}
                    </div>
                </div>
            </div>
        </>
    );
}
export default CardsSettings;